<template>
    <div class="joinMain">
        <p class="current">当前位置：<span>供应商入驻</span></p>
        <div class="join-box">
           <div class="mixWidth">
            <div v-for="item in vsData" :key="item.id" v-if="vsData != ''">
                    <div class="exper-div" @click="getCompanyInfo(item.id)">
                        <div class="joinImageWidth" :style="'box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);background-image:url('+item.firstFile.FileUrl+');background-repeat: no-repeat;background-size: cover;'">
                            
                        </div>
                        <div class="expertInfo">
                            <div class="info-top">
                                <div>
                                    <p class="title-p">{{ item.name }}</p>
                                </div>
                               
                                
                            </div>
                            <div class="info-bottom">
                                <div>
                                    <p>ID：{{ item.id }}</p>
                                    <p>姓名：{{ item.contact }}</p>
                                    <p>手机：{{ item.phone }}</p>
                                </div>
                                 <div class="resultJoin">
                                    <el-result v-if="(item.audit_status=='1')" icon="success" title="审核通过"></el-result>
                                    <el-result v-if="(item.audit_status=='2')" icon="error" title="审核不通过"></el-result>
                                    <el-result v-if="(item.audit_status=='3')" icon="warning" title="审核中"></el-result>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-divider   ></el-divider>
            </div>
            <div v-if="vsData == ''" class="NullVsData">
                <P>亲，未找到记录~</P>
            </div>
            <div class="elButoon">
                <el-button  type="primary" @click="addJoin">新增企业</el-button>
            </div>
            <div class="pagination">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="10"
                    :pager-count="widthNew?11:5"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
           </div>
           
        </div>
            
    </div>
</template>

<script>
export default{
    data(){
        return{
            company: [],
            total: 0,
            vsData:  [],
            hideOnSinglePage: true,
            widthNew: false,
         
        }
    },
    watch: {
        '$route' () {
            this._initData();//我的初始化方法
        }
    },
    methods:{
        getCompanyInfo(id){
            this.$router.push({
            path: '/companyDetail',
            query: {
                key: id,
                currentName: '公司详情'
            }
            })
        },
        listByUser(data){
            this.$store.dispatch('join/listByUser',data)
                .then((res) => {
                    if(res.ok){
                        if(res.data != '' && res.data != null){
                            this.vsData = res.data.items
                            this.total = res.data.total
                            if(this.total <= 10){
                                this.hideOnSinglePage = true
                            }else{
                                this.hideOnSinglePage = false
                            }

                        }else{
                            this.vsData = []
                        }
						
                    } else if(res.code == -1 && res.msg == '未登录或超时'){
                        this.$notify({
                            title: '提示',
                            message: '未登录或超时，请重新登陆',
                            type: 'error'
                        })
                        this.$router.push('/login')
                        
                    }
                })
        },
        addJoin(){
            this.$router.push({
                path: '/join'
            })
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
           // this.currentChange = val
           // console.log(value);
           let data = {
                pageNum: val,
                pageSize: 10,
                keywords: ''
           }
           this.listByUser(data)
        },
       
    },
    mounted(){

        if(localStorage.getItem('token')){
            let data = {
                pageNum: 1,
                pageSize: 10,
                keywords: ''
            }
            this.listByUser(data)
        } else {
            // 如果缓存不存在跳转到登陆页
            this.$router.push({
                path: '/login'
            })
        }

    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
       
    }
}
</script>
<style scoped lang="scss">
.joinMain{
    width: 1200px;
    padding: 10px 0;
    margin: 45px auto;
    .current{
        margin-top: -45px;
        position: relative;
        font-size: 17px;
        color: #333;
        span{
            font-size: 16px;
            cursor: pointer;
            color: #666666;
        }
    }
    .join-box{
        width: 1200px;
        margin: 25px auto;
        position: relative;
        .exper-div{
            cursor: pointer;
            .expertInfo{
                width: 980px;height: 130px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 18px;
                margin-left: 20px;
                .title-p{
                    width: 580px;height: 40px;
                    font-size: 22px;
                }
            }
            .info-bottom{
                font-size: 16px;
                color: #bbb;
                margin-top: 10px;
                line-height: 25px;
                display: flex;
                justify-content: space-between;
                .resultJoin{
                    margin-top: -20px;
                }
            }
        }
        .NullVsData{
            width: 1180px;height: 100px;
            p{
                text-align: center;
                font-size: 20px;
            }
        }
        .elButoon{
            position: absolute;
            bottom: -20px;
            left: 10px;
            width: 300px;height: 42px;
            .el-button{
                width: 100%;
            }

        }
        .pagination{
            margin-top: 40px;
            text-align: right;
        }
    }
}

.el-divider{
  background-color: #f2f2f2;
}


@media screen and (min-width: 541px) {
    .mixWidth{
        min-height: calc(100vh - 260px);
        .exper-div{
            width: 1180px;
            display: flex;
            justify-content: flex-start;
            height: 130px;
            margin: 10px 0 40px 10px;
            .joinImageWidth{
                width: 180px; height: 130px;
            }
            img{
                width: 180px;height: 130px;
                line-height: 18px;
            }
        }
    }
    
}
@media screen and (max-width: 540px) {
    .joinMain{
        width: 95%;
        margin: 45px auto;
        .current{
            padding-left: 7px;
        }
        .join-box{
            width: 100%;
            margin: 15px auto;
            .mixWidth{
                width: 100%;
                padding: 10px 10px;
            }
            .exper-div{
                margin: 0px auto;
                .expertInfo{
                    width: 100%;height: 150px;
                    font-size: 14px;
                    margin-left: 0px;
                    .title-p{
                        width: 100%;
                        font-size: 18px;
                    }
                    .resultJoin{
                        margin-top: -20px;
                    }
                }
                .joinImageWidth{
                    width: 100%; height: 200px;
                }
            }
        }
    }
    
 
    
}
</style>

<style>
@media screen and (min-width: 541px) {
    .resultJoin .el-result .icon-success{ 
        width: 50px;
    }
    .resultJoin .el-result{
        padding: 0px 5px;
    }
    .resultJoin .el-result__icon{
        height: 53px;
    }
     .resultJoin .el-result__title p{
        margin-top: -5px;
        font-size: 18px;
    }
}
@media screen and (max-width: 540px) {
    .resultJoin .el-result .icon-success{ 
        width: 40px;
    }
    .resultJoin .el-result{
        padding: 0px 5px;
    }
    .resultJoin .el-result__icon{
        height: 43px;
    }
    .resultJoin .el-result__title p{
        font-size: 14px;
    }
}
</style>